// extracted by mini-css-extract-plugin
export var button = "Disclaimer-module--button--5Y7qk";
export var cookieWrapper = "Disclaimer-module--cookieWrapper--EucS6";
export var hidden = "Disclaimer-module--hidden--ELiA9";
export var innerWrapper = "Disclaimer-module--innerWrapper--AcUTR";
export var preview = "Disclaimer-module--preview--bbk3q";
export var text = "Disclaimer-module--text--UlNCp";
export var title = "Disclaimer-module--title--09uOo";